import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import AlertDismissable from './AlertDismissable';

class NotHaveAccess extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false
        }
    }
    componentDidMount() {
        this.timeout = setTimeout(() => {
            this.props.dispatch(push('/'));
        }, 3000);
      }

    componentWillUnmount() {
        clearTimeout(this.timeout)
      }

    render() {
        return (
            <div className="container">
                <AlertDismissable>
                    Sorry, you do not have permission to view this page. Redirecting to home page...
                </AlertDismissable>
            </div>
        )
    }
}

export default connect()(NotHaveAccess);